@switch (version) { @case (1) {
<fgbcl-language-selector [visibleLanguagesByLcid]="visibleLanguagesByLcid"></fgbcl-language-selector>
} @case (2){
<fgbcl-language-selector-with-flag [visibleLanguagesByLcid]="visibleLanguagesByLcid"></fgbcl-language-selector-with-flag>
} }
